import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { spotPriceLoader } from "@/lib/spotSnapshot";

const SpotprisOmrade = lazy(() => import("@/pages/spotpris/SpotprisOmrade"));

export const Route = createFileRoute("/spotpris/elomrade-se4")({
  // Spotpriserna hämtas på servern så att tabeller och nyckeltal finns i HTML:en.
  loader: spotPriceLoader,
  head: () => seoHead("/spotpris/elomrade-se4"),
  component: () => <SpotprisOmrade />,
});
